<app-menu *ngIf="userService.isLoggedIn() && isNotChangePassword()"> </app-menu>
<!-- ======= Header ======= -->
<header id="header" class="fixed-top header-transparent" *ngIf="!userService.isLoggedIn()">
    <div class="container d-flex align-items-center justify-content-between">

        <div class="logo">
            <a><img src="../../../assets/images/TalH Logo 01 - Positive-01.png" alt="" class="img-fluid"></a>
        </div>

        <nav id="navbar" class="navbar">
            <ul>
                <li><a class="nav-link" href="#">{{ 'General.ABOUT_VCapital' | translate }}</a></li>
                <!-- <li><a class="nav-link" [routerLink]="['/opportunities/opportunity-list']">{{ 'OPPORTUNITIES' | translate }}</a></li> -->
                <li><a class="nav-link" [routerLink]="['/faq/faqs']">{{ 'General.FAQ' | translate }}</a></li>
                <li><a class="nav-link" [routerLink]="['/faq/support-and-help']">{{ 'General.CONTACT_US' | translate }}</a></li>
            </ul>
            <ul>
                <li class="lang-toggle-item">
                    <app-language-toggle></app-language-toggle>
                </li>
                <li><a class="getstarted" [routerLink]="['/authentication/login']">{{ 'General.GET_STARTED' | translate }}</a></li>
            </ul>
            
            <i class="bi bi-list mobile-nav-toggle"></i>
        </nav><!-- .navbar -->

    </div>
</header><!-- End Header -->

<main>
    <router-outlet></router-outlet>
</main>
<app-footer></app-footer>